import React, {useState} from "react";
import apiFetch from "../../utils/apiFetch";
import { Form } from "react-bootstrap";
import FontAwesome from 'utils/FA';
import { faTimes } from "@fortawesome/pro-light-svg-icons/faTimes";
import { faCheck } from "@fortawesome/pro-light-svg-icons/faCheck";
import { faExclamationTriangle } from '@fortawesome/pro-solid-svg-icons/faExclamationTriangle';
import ModalRoot from "../ModalRoot";
import registeredComponent from "../../utils/registeredComponent";
import {filterDuck, duckify} from "../../utils/duckify";
import { contacts as contactsDuck } from '../../ducks';
import {modals} from "../../ducks";
import LinkButton from "../LinkButton/LinkButton";
import FALabel from "../shared/FALabel";
import InfoTooltip from '../shared/InfoTooltip';
import { connect } from 'react-redux';
import ModalComponent from '../ModalComponent';
import { UnexpectedError } from '../DefaultModals';

const BillingAccountAccessPicker = ({kidContactId, payerContact, billingPayer, billingAccount, relatedContacts, showAudits, deleteBillingAccountAccess}) => {
  const primaryBillingAccountAccess = billingAccount.billing_account_accesses.find(baa => baa.contact_id === payerContact.id);
  const otherBillingAccountAccesses = billingAccount.billing_account_accesses.filter(baa => baa.contact_id !== payerContact.id);

  const [billingAccountAccesses, setBillingAccountAccesses] = useState(otherBillingAccountAccesses);
  const [billingAccountAccessEmailsEnabled, setBillingAccountAccessEmailsEnabled] = useState(billingAccountAccesses.map(baa => baa.email_notifications_enabled));
  const [primaryBillingAccountAccessEmailsEnabled, setPrimaryBillingAccountAccessEmailsEnabled] = useState(primaryBillingAccountAccess ? primaryBillingAccountAccess.email_notifications_enabled : false);
  const [showNewRow, setShowNewRow] = useState(false);

  const toggleChecked = (billingAccountAccessId, isPersisted, value, setter) => {
    if(isPersisted) {
      apiFetch.put(
        {},
        `billing_account_accesses/${billingAccountAccessId}`,
        {
          billing_account_access: {
            email_notifications_enabled: !value
          }
        }
      );

      const idx = billingAccountAccesses.findIndex(e => e.id === billingAccountAccessId);
      let newValues = billingAccountAccessEmailsEnabled;
      newValues[idx] = !newValues[idx];
      setBillingAccountAccessEmailsEnabled(newValues);
    }
    setter(!value);
  }

  const addBillingAccountAccessRow = () => {
    setShowNewRow(true);
  }

  const postBillingAccountAccess = (contactId, emailsEnabled) => {
    if(!contactId)
      return Promise.reject(new Error('No contactId'));

    return apiFetch.post(
      {},
      'billing_account_accesses',
      {
        billing_account_access: {
          billing_account_id: billingAccount.id,
          contact_id: contactId,
          email_notifications_enabled: emailsEnabled
        }
      }
    );
  }

  const removeRowFromUI = (key) => {
    const newList = billingAccountAccesses.filter((e, i) => i !== key);
    setBillingAccountAccesses(newList);

    const newEmailsEnabledList = billingAccountAccessEmailsEnabled.filter((e, i) => i !== key);
    setBillingAccountAccessEmailsEnabled(newEmailsEnabledList);
  }


  const allContactsWithBillingAccountAccesses = () => {
    let ids = billingAccountAccesses.map(billingAccountAccess => billingAccountAccess.contact).filter(e => e).map(e => e.id);

    if(primaryBillingAccountAccess) {
      ids = ids.concat(primaryBillingAccountAccess.contact.id);
    }

    return ids;
  }

  const ConfirmDelete = connect()(({dispatch, billingAccountAccessId, deleting = false}) => (
    <ModalComponent title="Confirm Delete"
                    buttons={[
                      <button className="btn btn-danger"
                              disabled={deleting}
                              onClick={() => {
                                dispatch(modals.actions.update({deleting: true}));
                                apiFetch.delete(
                                  {},
                                  `billing_account_accesses/${billingAccountAccessId}`,
                                  {}
                                )
                                .then(() => removeRowFromUI(billingAccountAccessId))
                                .then(() => dispatch(modals.actions.hide()))
                                .catch((e) => console.error(e) &&  dispatch(modals.actions.show('UnexpectedError')));
                              }}>{deleting ? 'Deleting...' : 'Delete'}</button>
                    ]}
                    closeText="Cancel">
      <p>Are you sure you would like to remove shared access for this account?</p>
    </ModalComponent>)
  );

  const PersistedBillingAccountAccessRow = ({contact, billingAccountAccess, emailsWereEnabled, removeSelfFromUI}) => {
    const [emailsEnabled, setEmailsEnabled] = useState(emailsWereEnabled);

    const clickX = () => {
      deleteBillingAccountAccess(billingAccountAccess.id);
      removeSelfFromUI();
    }

    return <tr>
      <td className={'billing-account-access-header'}>Shared Access</td>
      <td>
        <a href={`/contacts/${contact.id}/billing`}>{contact.name}</a>
      </td>
      <td>
        <span className={'billing-account-access-toggle'}>
          {!!contact.email && (
            <Form.Check
              type={'switch'}
              checked={contact.email && emailsEnabled}
              onChange={_e => toggleChecked(billingAccountAccess.id, true, emailsEnabled, setEmailsEnabled)}
            />
          )}
          {!contact.email && (
            <InfoTooltip
              icon={faExclamationTriangle}
              className={'red'}
              nbsp
            >
              This contact has no email address
            </InfoTooltip>
          )}
        </span>
      </td>
      <td>
        <button className={'btn btn-xs billing-account-access-delete'} onClick={clickX}><FontAwesome icon={faTimes}/></button>
      </td>
    </tr>;
  }

  const NewBillingAccountAccessRow = () => {
    const [selectedContactId, setSelectedContactId] = useState(null);
    const [emailsEnabled, setEmailsEnabled] = useState(true);

    const clickY = () => {
      postBillingAccountAccess(selectedContactId, emailsEnabled)
        .then(resp => {
          const newContact = relatedContacts.find(c => c.id === selectedContactId);
          const billingAccountAccess = resp.billing_account_access;
          billingAccountAccess.contact = newContact;
          const newList = billingAccountAccesses.concat(billingAccountAccess);

          setBillingAccountAccesses(newList);
          setBillingAccountAccessEmailsEnabled(billingAccountAccessEmailsEnabled.concat(emailsEnabled));
          setShowNewRow(false);
        })
        .catch(() => null);
    }

    return <tr>
      <td className={'billing-account-access-header'}>Shared Access</td>
      <td>
        <select placeholder={'Select Contact'} onChange={(e) => setSelectedContactId(e.target.value)}>
          <option>Select Contact</option>
          {
            relatedContacts
              .filter(contact => !allContactsWithBillingAccountAccesses().includes(contact.id))
              .map(contact => {
                return <option value={contact.id} key={contact.id}>{contact.name}</option>
              })
          }
        </select>
      </td>
      <td>
        <span className={'billing-account-access-toggle'}>
          <Form.Check
            type={'switch'}
            checked={emailsEnabled}
            onChange={_e => setEmailsEnabled(!emailsEnabled)}
          />
        </span>
      </td>
      <td>
        <button className={'btn btn-xs billing-account-access-delete'} onClick={() => setShowNewRow(false)}><FontAwesome icon={faTimes}/></button>
        <button className={'btn btn-xs btn-primary billing-account-access-persist'} onClick={clickY}><FontAwesome icon={faCheck}/></button>
      </td>
    </tr>;
  }

  const AddAdditionalContact = () => {
    return <LinkButton
      className='add-item-button'
      onClick={addBillingAccountAccessRow}
      content={<FALabel icon='plus-circle' iconFirst label={<React.Fragment>&nbsp;Add additional Contact</React.Fragment>}/>}
    />;
  }

  return <React.Fragment>
    <h2>
      <a href={`/contacts/${payerContact.id}/billing`}>
        {payerContact.name} ({billingPayer ? billingPayer.percent : '0.0'}% Responsible)
      </a>
    </h2>
    <table className={'billing-account-access-picker-table'}>
      <thead>
      <tr>
        <td/>
        <td className={'billing-account-access-header'}>Contact</td>
        <td className={'billing-account-access-header'}>Notifications</td>
        <td>
          <LinkButton onClick={() => showAudits(billingAccount.id)} content={'View Changes'}/>
        </td>
      </tr>
      </thead>
      <tbody>
      <tr>
        <td className={'billing-account-access-header'}>Billing Account</td>
        <td><a href={`/contacts/${billingAccount.contact.id}/billing`}>{billingAccount.contact.name}</a></td>
        <td>
          {!!primaryBillingAccountAccess &&
            <span className={'billing-account-access-toggle'}>
              {!!billingAccount.contact.email && (
                <Form.Check
                  type={'switch'}
                  checked={primaryBillingAccountAccessEmailsEnabled}
                  onChange={_e => toggleChecked(primaryBillingAccountAccess.id, true, primaryBillingAccountAccessEmailsEnabled, setPrimaryBillingAccountAccessEmailsEnabled)}
                />
              )}
              {!billingAccount.contact.email && (
                <InfoTooltip
                  icon={faExclamationTriangle}
                  className={'red'}
                  nbsp
                >
                  This contact has no email address
                </InfoTooltip>
              )}
            </span>
          }
        </td>
        <td/>
      </tr>
      {
        billingAccountAccesses.map((baa, i) => {
          return <PersistedBillingAccountAccessRow key={i} contact={baa.contact} billingAccountAccess={baa} emailsWereEnabled={billingAccountAccessEmailsEnabled[i]} removeSelfFromUI={() => removeRowFromUI(i)}/>;
        })
      }
      {
        showNewRow && <NewBillingAccountAccessRow/>
      }
      <tr>
        <td/>
        <td>
          <AddAdditionalContact/>
        </td>
        <td/>
        <td/>
      </tr>
      </tbody>
    </table>
    <ModalRoot
      modals={{
        ConfirmDelete,
        UnexpectedError
      }}
    />
  </React.Fragment>;
}

const mapDucksToProps = (props) => {
  return {
    relatedContacts: filterDuck(contactsDuck, {contact_id: props.kidContactId})
  };
}

const mapDispatchToProps = (dispatch) => ({
  showAudits: (associated_id) => dispatch(modals.actions.show('AuditViewer', {
    associated_id,
    resource: 'billing_account_accesses'
  })),
  deleteBillingAccountAccess: (billingAccountAccessId) => {
    dispatch(modals.actions.show('ConfirmDelete', {billingAccountAccessId}));
  }
});

export default registeredComponent('BillingAccountAccessPicker')(duckify(mapDucksToProps, () => ({}), mapDispatchToProps)(BillingAccountAccessPicker));
